//
// Class to help organize images in a dynamic manner
// Requirement is like this
//    one image show quite big
//    1+ images, scale down if necessary and wrap to next line
//               ! problem with simple html/css is that the item in the next line would just expand 
//               but, the size of the items is dynamic and determined by the first row
//
export default class WrapPanel {

    private content: JQuery;
    private sizeCssClass: string;
    private imagesContainersObserver;

    constructor(content: JQuery, sizeCssClass: string = "wrapPanelDefaultSize") {
        this.content = content;
        this.sizeCssClass = sizeCssClass;
        this.content.addClass("wrapPanel");

        $(window).resize(() => this.redimensionImages());
        this.imagesContainersObserver = new MutationObserver(() => this.redimensionImages());
        this.imagesContainersObserver.observe(content[0], { childList: true }); // interested in add/remove changes
    }

    public getItem(id: string): JQuery {
        let domImageContainer = this.content.children(`[data-datapointid='${id}']`);
        if (domImageContainer.length === 0) {
            return null;
        }

        return domImageContainer;
    }

    public addItem(id: string, itemContent: JQuery) {
        itemContent.addClass(this.sizeCssClass);
        itemContent.addClass("wrapPanelItem");
        itemContent.attr("data-datapointid", id);
        this.content.append(itemContent);
    }

    public removeItem(id: string) {
        this.content.find(`div[data-datapointid='${id}']`).remove();
    }

    public redimensionImages() {
        // Fixup the sizes of the image elements. This becomes important after a wrap where the browser correctly expands the last element
        const imageDoms = this.content.children("div");
        if (imageDoms.length > 0) {
            imageDoms.first().css("max-width", "");

            const firstWidth = imageDoms.first().width();
            imageDoms.each((idx, elem) => {
                if (idx > 0) {
                    $(elem).css("max-width", firstWidth);
                }
            });
        }
    }
}
